import { Component, input } from '@angular/core';

/**
 * Container para ações (botões) associadas a um input.
 *
 * Projeta botões (`ai-button`) agrupados ao lado de um campo.
 */
@Component({
    selector: 'ai-input-actions',
    standalone: true,
    templateUrl: './input-actions.component.html',
})
export class InputActions {
    /** Posição das ações (reservado para uso futuro). */
    position = input<string>('');
}
